export default __webpack_public_path__ + "static/media/49919887071_d280c67fdd_b.b5bd2693.jpg";